module.exports = __webpack_public_path__ + "img/PEC8000.de239018.png";